import React from 'react';
import { GuestGroupsByDepthKey } from '../Groups/types';
import UpdateGuestGroup from './UpdateGroup';

export const UpdateGroup: React.FunctionComponent = () => <UpdateGuestGroup depth={GuestGroupsByDepthKey.GROUPS} />;
export const UpdateSection: React.FunctionComponent = () => <UpdateGuestGroup depth={GuestGroupsByDepthKey.SECTIONS} />;
export const UpdateSubSection: React.FunctionComponent = () => (
    <UpdateGuestGroup depth={GuestGroupsByDepthKey.SUB_SECTIONS} />
);
